
export default class I18n {
  constructor(config) {
    this._parseConfig(config);
    this._setGlobal();
    this._setVerbosity();
    this.callbacks = [];
    this.localeFile = {};
  }

  static async create(config) {
    const i18n = new I18n(config);
    await i18n._loadFile();
    return i18n;
  }

  _parseConfig(config) {
    this.config = {
      language: config.language || 'de',
      path: config.path || '/locales',
      extension: config.extension || '.json',
      setGlobal: config.setGlobal !== false,
      verbose: config.verbose !== false
    };
  }

  _setGlobal() {
    if (this.config.setGlobal) {
      window.__ = this.__.bind(this);
    }
  }

  _setVerbosity() {
    this._logger = {
      info: () => {},
      error: () => {},
      warn: () => {},
      log: () => {}
    };

    if (this.config.verbose) {
      this._logger = console;
    }
  }

  async _loadFile() {
    try {
      const response = await fetch(
        `${this.config.path}/${this.config.language}${this.config.extension}`
      );

      if (!response.ok) throw new Error('File not found');

      this.localeFile = await response.json();
      this._logger.info('[browser-i18n] File loaded successfully.');
    } catch (err) {
      this._logger.error('[browser-i18n] Cannot load file:', err);

      if (this.config.language !== 'de') {
        this._logger.warn('[browser-i18n] Falling back to Deutsch.');
        this.config.language = 'de';
        await this._loadFile();
      }
    }
  }

  __(text, ...args) {
    let translated = this.localeFile[text];

    if (translated === undefined) {
      this._logger.log(
        `Missing translation in '${this.config.language}${this.config.extension}', add:\n"${text}": "${text}"`
      );
      translated = text; // fallback to original
    }

    return args.length > 0 ? console.log(translated, args) : translated;
  }
}